const Activity = {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    USER_DATA: 'USER_DATA',
    AUTH_DATA: 'AUTH_DATA',
    AUTH_PERMISSIONS_DATA_PERSIST: 'AUTH_PERMISSIONS_DATA_PERSIST',
    ATV_LANG: 'ATV_LANG'
}

const InitialState = {
    credentials: false,
    user: false,
    auhPermissions: [],
    atvLang: null
};

export const AuthSession = {
    storeToken(payload) {
        return { type: Activity.ACCESS_TOKEN, payload }
    },
    storeUserData(payload) {
        return { type: Activity.USER_DATA, payload }
    },
    storeData(payload){
        return {type: Activity.AUTH_DATA, payload}
    },
    storeAuthPermissions(payload){
        return {type: Activity.AUTH_PERMISSIONS_DATA_PERSIST, payload}
    },
    storeAtvLang(payload){
        return {type: Activity.ATV_LANG, payload}
    },
    logout() {
        return AuthSession.storeData(InitialState);
    }
};

const auth = (state = InitialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case Activity.AUTH_DATA:
            return payload;
        case Activity.ACCESS_TOKEN:
            return { ...state, credentials: payload};
        case Activity.USER_DATA:
            return { ...state, user: payload };
        case Activity.AUTH_PERMISSIONS_DATA_PERSIST:
            return { ...state, authPermissions: payload };
        case Activity.ATV_LANG:
            return { ...state, atvLang: payload };
        default:
            return state;
    }
}

export default auth;
